import _ from "lodash";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import MediaModal from "UIComponents/MediaModal";
import TextMoreLess from "UIComponents/TextMoreLess";
import UIModal from "UIComponents/UIModal";
import classes from "./StudentResponseV2.scss";
import {
  GoalsOutlined,
  TableOutlined,
  ChevronRightOutlined,
  ChevronLeftOutlined,
  SinglePointRubricOutlined,
  RubricOutlined,
  ChecklistOutlined,
  ScoreBasedAssessmentOutlined,
  SortOutlined,
} from "@toddle-edu/ds-icons";
import { ASSESSMENT_TOOLS } from "@toddle-edu/common-utils";
import { Button, IconButton } from "@toddle-edu/ds-web";
import { getCriteriaSetOfPypType } from "modules/Services";
import { AssessmentToolPreviewModalV2 } from "UnitPlans/components/LibraryCommonComponents";
import {
  getAttachmentsToDisplayWithPostConfig,
  checkAchievementCriteriaExists,
  checkAssessmentHasPypEvaluation,
  getAssessmentToolText,
  getShowAssessmentTool,
  reorderTools,
  getScoreValueElementRatings,
  getStaffElementRemarkMessage,
} from "ClassRoom/modules/utils";
import classNames from "classnames";
import PypEvaluationV2 from "AssessmentEvaluation/components/PypEvaluationV2";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import { AttachmentsContainer } from "./AttachmentsContainer/AttachmentsContainer";
import { getSettingValue } from "modules/PermissionModule";
import {
  getFilteredToolResponsesByUserTypeMemoized,
  isPortfolioParityEnabled,
  isPortfolioParityEnabledAndIsJournalRoute,
} from "AppComponents/Post/utils";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import PostDetail from "Post/routes/PostDetail";
import { updatePostStatus } from "Journal/modules/JournalModule";
import { getScoreDetailsMemoize } from "ScoreCategories/modules/ScoreCategoriesModule";
import {
  ASSESSMENT_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
} from "Constants/stringConstants";
import { syncPostCommentsCache } from "Post/modules/PostGraphqlHelpers";
import { PostCommentFragment } from "Post/modules/PostFragments";
import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import { getStudentAssignmentMicrosoftLink } from "ClassRoom/modules/ClassRoomModule";

const BLANK_ARRAY = [];
const BLANK_OBJECT = {};
const renderAssessmentToolCard = params => {
  const {
    t,
    node,
    itemCardStyle,
    setShowAssessmentTool,
    setAssessmentToolInfo,
    evaluationContentClass,
    assessmentFields,
    iconSize = "large",
    assessmentToolTextStyle,
  } = params;

  const assessmentTool = _.get(node, "assessmentToolItem", BLANK_OBJECT);
  const assessmentToolId = _.get(node, "assessmentToolItem.id", "");
  const assessmentToolType = _.get(node, "assessmentToolType", "");

  //if (assessmentToolType === "SCORE") return;

  const isTeacherEvaluationEnable = _.get(
    node,
    "isTeacherEvaluationEnable",
    false
  );
  const isStudentEvaluationEnable = _.get(
    node,
    "isStudentEvaluationEnable",
    false
  );

  const onClickAssessmentToolCard = () => {
    setShowAssessmentTool(true);
    if (setAssessmentToolInfo) {
      setAssessmentToolInfo({
        assessmentToolIdLocal: assessmentToolId,
        assessmentToolTypeLocal: assessmentToolType,
        isTeacherEvaluationEnabledLocal: isTeacherEvaluationEnable,
        isStudentEvaluationEnabledLocal: isStudentEvaluationEnable,
      });
    }
  };

  const { assessmentToolText } = getAssessmentToolText({
    t,
    assessmentToolType,
    assessmentTool,
  });

  const getAssessmentToolIcon = type => {
    switch (type) {
      case "RUBRIC":
        return <RubricOutlined size={iconSize} />;
      case "SINGLE_POINT_RUBRIC":
        return <SinglePointRubricOutlined size={iconSize} />;
      case "CHECKLIST":
        return <ChecklistOutlined size={iconSize} />;
      case "SCORE":
        return <ScoreBasedAssessmentOutlined size={iconSize} />;
      case ASSESSMENT_GRADE_BOUNDARY:
      case ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY:
      case ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY:
      case ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY:
        return <SortOutlined size={iconSize} />;
      default:
        return <TableOutlined size={iconSize} />;
    }
  };

  const showAssessmentToolCard =
    getShowAssessmentTool({
      assessmentTool,
      assessmentToolType,
      allFields: assessmentFields,
    }) &&
    (isTeacherEvaluationEnable || isStudentEvaluationEnable);

  return (
    showAssessmentToolCard && (
      <div
        className={classes.evaluationItemContainer}
        key={_.get(node, "id", "")}
        style={{ ...itemCardStyle }}
      >
        <div
          className={evaluationContentClass}
          onClick={onClickAssessmentToolCard}
        >
          <div className={classes.evaluationIcon}>
            {getAssessmentToolIcon(assessmentToolType)}
          </div>
          <div
            className={classes.evaluationTitle}
            style={assessmentToolTextStyle}
          >
            {assessmentToolText}
          </div>
        </div>
      </div>
    )
  );
};

const StudentResponseEvaluation = props => {
  const {
    evaluationTextStyle,
    isPreviewCard,
    setShowAssessmentTool,
    t,
    setShowRateLearningGoalsModal,
    showRateLearningGoals,
    isFullWidth,
    assessmentTools,
    setAssessmentToolInfo,
    isTeacherEvaluationEnabled,
    isStudentEvaluationEnabled,
    assessmentFields,
    evaluationCardStyle,
    iconSize,
    assessmentToolTextStyle,
    showAssessmentToolCard,
    onClickMedia,
    totalAttachments,
  } = props;

  const evaluationContentContainerClass = classNames({
    [classes.evaluationContentContainer]: !isPreviewCard,
    [classes.evaluationContentContainerPreview]: isPreviewCard,
  });

  const evaluationContentClass = classNames({
    [classes.evaluationContent]: true,
    [classes.evaluationContentPreview]: isPreviewCard,
  });

  const updatedItemCardStyle = {
    minWidth: isFullWidth ? "100%" : "300px",
    paddingRight: "16px",
    ...(evaluationCardStyle ?? {}),
  };

  return (
    (showAssessmentToolCard || showRateLearningGoals) && (
      <div className={classes.evaluationContainer}>
        {!isPreviewCard && (
          <div className={classes.evaluationText} style={evaluationTextStyle}>
            {t("common:evaluation")}
          </div>
        )}
        <div className={evaluationContentContainerClass}>
          {showAssessmentToolCard &&
            _.map(
              reorderTools({ assessmentTools, hasEdges: false }),
              ({ node }, index) => {
                const setShowAssessmentToolLocalFn = state => {
                  const reorderedTools = reorderTools({
                    assessmentTools,
                    hasEdges: false,
                  });
                  const indexOfCurrentNode = _.findIndex(
                    reorderedTools,
                    ({ node: nodeToFind }) => nodeToFind.id == node.id
                  );
                  if (showNewTheatreMode()) {
                    onClickMedia({
                      activeIndex:
                        Math.max(totalAttachments, 0) + indexOfCurrentNode,
                    });
                  } else setShowAssessmentTool(state);
                };
                return renderAssessmentToolCard({
                  t,
                  node,
                  itemCardStyle: updatedItemCardStyle,
                  evaluationContentClass,
                  setShowAssessmentTool: setShowAssessmentToolLocalFn,
                  setAssessmentToolInfo,
                  isTeacherEvaluationEnabled,
                  isStudentEvaluationEnabled,
                  assessmentFields,
                  iconSize,
                  assessmentToolTextStyle,
                });
              }
            )}

          {showRateLearningGoals && (
            <div
              className={classes.evaluationItemContainer}
              style={{ ...updatedItemCardStyle }}
            >
              <div
                className={evaluationContentClass}
                onClick={() => {
                  if (showNewTheatreMode()) {
                    onClickMedia({
                      showLearningGoalsInTheatre: true,
                    });
                  } else setShowRateLearningGoalsModal(true);
                }}
              >
                <div className={classes.evaluationIcon}>
                  <GoalsOutlined
                    size={isPortfolioParityEnabled() ? "x-small" : "large"}
                    variant={"link"}
                  />
                </div>
                <div className={classes.evaluationTitle}>
                  {t("common:learning_goals")}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  );
};

const RateOnLearningGoalsModalContent = props => {
  const {
    isComplete,
    parentId,
    parentType,
    showToggleStudentPypEvaluateStatus,
    evaluateIBPYPElements,
    studentDetails,
    assessmentFields,
    ibPYPElementRatings,
    isEvaluated,
    curriculumProgramType,
    course,
    t,
    setShowRateLearningGoalsModal,
  } = props;
  return (
    <React.Fragment>
      <div className={classes.modalHeader}>
        <span>{t("common:learning_goals")}</span>
        <span className={classes.actionButtons}>
          <Button
            variant={"outlined"}
            size={"medium"}
            onClick={() => setShowRateLearningGoalsModal(false)}
          >
            {t("common:cancel")}
          </Button>
        </span>
      </div>
      <div className={classes.modalBody}>
        <div className={classes.innerWrapper}>
          <PypEvaluationV2
            isComplete={isComplete}
            parentId={parentId}
            parentType={parentType}
            showToggleStudentPypEvaluateStatus={
              showToggleStudentPypEvaluateStatus
            }
            evaluateIBPYPElements={evaluateIBPYPElements}
            studentDetails={studentDetails}
            assessmentFields={assessmentFields}
            ibPYPElementRatings={ibPYPElementRatings}
            isEvaluated={isEvaluated}
            curriculumProgramType={curriculumProgramType}
            course={course}
            isMinimalDesign={true}
            showCriteriaDescriptorButton={true}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const RateOnLearningGoalsPreviewModal = props => {
  const { setShowRateLearningGoalsModal } = props;
  return (
    <UIModal
      isOpen={true}
      modalContent={classes.modalContent}
      onRequestClose={() => setShowRateLearningGoalsModal(false)}
    >
      <RateOnLearningGoalsModalContent {...props} />
    </UIModal>
  );
};

const MediaModalWrapper = ({
  attachments,
  toggleMediaModal,
  showMediaModal,
  evaluationContent,
  assessmentToolsEvaluationDetails = {},
  studentSubmissionId,
  assessmentId,
  assignmentId,
  post,
  t,
  curriculumProgramType,
  showLearningGoalsInTheatre = false,
  hasRateLearningGoals,
  canCreateComment,
  postViewMode,
  updatePostStatus,
  onPostActionClick,
  hideViews,
  hideLike,
  hideComments,
  hideLearninGoals,
  hideTaggedStudents,
  hideUnitDetails,
  showTaggedFolders,
  postRatedLearningGoalsDetails,
  taggedStudents,
  shouldShowEvaluationTools = true,
  canDownloadMedia = true,
  postIdFromParent,
  showCommentButton,
  isViewFromPostPage = false,
  cardType,
  canEditOrDelete,
  hideMoveToDraftOption,
  hasManageAccess,
  learningCourseId,
}) => {
  const currentAttachments = _.get(attachments, "attachments", BLANK_ARRAY);
  const activeAttachment = _.get(
    currentAttachments,
    _.get(attachments, "activeIndex", 0),
    BLANK_OBJECT
  );
  const assessmentTools = shouldShowEvaluationTools
    ? _.map(
        _.get(evaluationContent, "assessmentTools.edges", BLANK_ARRAY),
        tool => tool
      )
    : BLANK_ARRAY;
  const learningGoalTool = [];
  if (shouldShowEvaluationTools && hasRateLearningGoals) {
    learningGoalTool.push({
      node: {
        id:
          _.get(assessmentToolsEvaluationDetails, "parentId", "") +
          "_LEARNING_GOALS",
        assessmentToolItem: {
          id:
            _.get(assessmentToolsEvaluationDetails, "parentId", "") +
            "_LEARNING_GOALS",
        },
        assessmentToolType: "LEARNING_GOALS",
      },
    });
  }
  const activeAttachmentIndex = showLearningGoalsInTheatre
    ? _.size(currentAttachments, 0) +
      _.size(assessmentTools, 1) +
      _.size(learningGoalTool) -
      1
    : _.get(attachments, "activeIndex", 0);

  const mediaAttachments = useMemo(
    () => ({ attachments: currentAttachments }),
    [currentAttachments]
  );
  const isJournalRoute = isPortfolioParityEnabledAndIsJournalRoute();

  return showMediaModal ? (
    showNewTheatreMode() ? (
      <TheatreModeV2
        mediaAttachments={mediaAttachments}
        studentSubmissionId={studentSubmissionId}
        activeAttachmentIndex={activeAttachmentIndex}
        toggleTheatreMode={toggleMediaModal}
        iframeIdSelector={"workbook-iframe-journal"}
        assessmentTools={[
          ..._.map(reorderTools({ assessmentTools, hasEdges: false }), tool =>
            _.get(tool, "node")
          ),
          ..._.map(learningGoalTool, tool => _.get(tool, "node")),
        ]}
        assessmentToolsEvaluationDetails={assessmentToolsEvaluationDetails}
        postRatedLearningGoalsDetails={postRatedLearningGoalsDetails}
        taggedStudents={taggedStudents}
        canDownloadMedia={canDownloadMedia}
        assessmentId={assessmentId}
        assignmentId={assignmentId}
        learningCourseIdFromProps={learningCourseId}
        sidePaneContent={
          !_.isNil(post) && !_.isEmpty(post) ? (
            <PostDetail
              postId={!_.isNil(postIdFromParent) ? postIdFromParent : post?.id}
              onCloseClick={() => toggleMediaModal(false)}
              showComment={false} // false to not show comments screen initially
              customDetailText={t("common:view_with_label_lowercase", {
                label: t("common:post"),
              })}
              assessmentId={assessmentId}
              isRightPaneChat={true}
              mediaMaxHeight={480}
              canCreateComment={canCreateComment}
              mode={postViewMode}
              updatePostStatus={updatePostStatus}
              isSidePaneContent={true}
              showCloseBtn={false}
              showCommentBackButton={true}
              showAttachmentAsMediaCard={true}
              onPostActionClick={onPostActionClick}
              hideViews={hideViews}
              hideLike={hideLike}
              hideComments={hideComments}
              hideLearninGoals={hideLearninGoals}
              hideTaggedStudents={hideTaggedStudents}
              hideUnitDetails={hideUnitDetails}
              showTaggedFolders={showTaggedFolders}
              showCommentButton={showCommentButton}
              isViewFromPostPage={isViewFromPostPage}
              cardType={cardType}
              canEditOrDelete={canEditOrDelete}
              hideMoveToDraftOption={hideMoveToDraftOption}
              hasManageAccess={hasManageAccess}
            />
          ) : null
        }
        isJournal={isJournalRoute}
      />
    ) : (
      <MediaModal
        toggleMediaModal={toggleMediaModal}
        attachments={[activeAttachment]}
        onWorkbookUpdateSuccessfully={() => toggleMediaModal(false)}
      />
    )
  ) : null;
};

const StudentResponseV2 = React.memo(props => {
  const {
    t,
    item,
    showSeeMore,
    containerStyle = {},
    responseStyle,
    horizontalCardStyle,
    showEvaluation,
    isPreviewCard,
    evaluationTextStyle,
    attachmentsContainerStyle,
    course,
    curriculumProgramType,
    getCriteriaSetOfPypType,
    isSidePaneContent,
    isFinalCriteriaSettingEnabled,
    mediaPlaceholderContainerStyle = {},
    evaluationCardStyle = {},
    scrollButtonsContainerStyle = {},
    attachmentCardWidth = 284, //required for scroll actions, pass this prop if you want to set mediaplaceholder width different than 284px
    showFullWidthItems = true,
    iconSize = "large",
    assessmentToolTextStyle = {},
    canUserSeeRateLearningGoals = true,
    setTheatreAttachmentIndex,
    theatreActiveAttachmentId,
    setTheatreAttachmentById,
    showTheatreModeOnInit = false,
    toggleParentMediaModalState,
    canCreateComment,
    postViewMode = "edit",
    updatePostStatus,
    onPostActionClick,
    sidePaneContainerStyle = {},
    setRefetchComment = () => {},
    hideViews,
    hideLike,
    hideComments,
    hideLearninGoals,
    hideTaggedStudents,
    hideUnitDetails,
    showTaggedFolders,
    postRatedLearningGoalsDetails,
    taggedStudents,
    shouldShowEvaluationTools = true,
    canDownloadMedia = true,
    userType,
    isViewFromPostPage = false,
    cardType,
    canEditOrDelete,
    hideMoveToDraftOption,
    getStudentAssignmentMicrosoftLink,
    hasManageAccess,
    postAttachments,
    learningCourseId,
  } = props;
  const [showAssessmentTool, setShowAssessmentTool] = useState(false);
  const [showRateLearningGoalsModal, setShowRateLearningGoalsModal] = useState(
    false
  );

  const [assessmentToolInfo, setAssessmentToolInfo] = useState({
    assessmentToolIdLocal: "",
    assessmentToolTypeLocal: "",
    isTeacherEvaluationEnabledLocal: false,
    isStudentEvaluationEnabledLocal: false,
  });

  const {
    assessmentToolIdLocal,
    assessmentToolTypeLocal,
    isTeacherEvaluationEnabledLocal,
    isStudentEvaluationEnabledLocal,
  } = assessmentToolInfo;

  const student = _.get(item, "student", BLANK_OBJECT);
  const studentAssignmentId = _.get(item, "id", "");
  const content = _.get(item, "assignment.content", BLANK_OBJECT);
  const assessmentId = _.get(content, "id", null);
  const assignmentId = _.get(item, "assignment.id", null);

  const isLearningGoalsEvaluationEnabled = _.get(
    content,
    "isLearningGoalsEvaluationEnabled",
    false
  );

  const assessmentToolTitle = _.get(content, "title.value", "");
  const assessmentToolEdges = _.get(
    content,
    "assessmentTools.edges",
    BLANK_ARRAY
  );

  const assessmentTools = _.filter(assessmentToolEdges, ({ node }) => {
    const assessmentToolType = _.get(node, "assessmentToolType");
    return !_.includes(
      showNewTheatreMode()
        ? ["COMMENT"]
        : [
            "COMMENT",
            ASSESSMENT_GRADE_BOUNDARY,
            ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
            ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
            ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
          ],
      assessmentToolType
    );
  });

  const commentTool = _.find(assessmentToolEdges, ({ node }) => {
    return _.get(node, "assessmentToolType") === "COMMENT";
  });

  const submission = _.get(item, "submission", BLANK_OBJECT);
  const response = _.get(submission, "response", "");

  const attachmentGroups = _.get(submission, "attachmentGroups", BLANK_OBJECT);

  const attachmentsToDisplay = getAttachmentsToDisplayWithPostConfig({
    attachmentGroups,
  });

  const isEvaluated = _.get(item, "isEvaluated", false);
  const isSharedWithStudent = _.get(item, "isSharedWithStudent", false);

  const toolResponsesData = getFilteredToolResponsesByUserTypeMemoized({
    toolResponses: _.get(item, "toolResponses", BLANK_OBJECT),
    userType,
    isSharedWithStudent,
  });
  const toolResponses = _.get(
    _.find(toolResponsesData, ({ toolId }) => toolId === assessmentToolIdLocal),
    "toolResponses",
    BLANK_OBJECT
  );

  const ibPYPElementRatings = _.get(item, "ibPYPElementRatings", BLANK_ARRAY);

  const isTeacherEvaluationEnabled = _.get(
    item,
    "assignment.isTeacherEvaluationEnabled",
    true
  );

  const isStudentEvaluationEnabled = _.get(
    item,
    "assignment.isStudentEvaluationEnabled",
    true
  );

  const commentMessage = getStaffElementRemarkMessage(
    _.get(item, "elementRemarks", BLANK_ARRAY)
  );

  const assessmentFields = _.get(
    content,
    "allFields",
    _.get(content, "fields", BLANK_ARRAY)
  );
  const field_list = _.get(content, "template.body.field_list", BLANK_ARRAY);
  const unitPlanFields = _.get(item, "unitPlanFields", BLANK_ARRAY);

  const { assessmentToolText } = getAssessmentToolText({
    t,
    assessmentToolType: assessmentToolTypeLocal,
    assessmentTool: _.get(
      _.find(assessmentTools, ({ node }) => {
        const assessmentToolType = _.get(node, "assessmentToolType", "");
        return assessmentToolType === assessmentToolTypeLocal;
      }),
      "node.assessmentToolItem",
      BLANK_OBJECT
    ),
  });

  const isEmptyAchievementCriteria = checkAchievementCriteriaExists({
    assessmentFields,
    curriculumProgramType,
    getCriteriaSetOfPypType,
  });

  const showRateLearningGoals =
    isLearningGoalsEvaluationEnabled &&
    checkAssessmentHasPypEvaluation({
      assessmentDetails: content,
      curriculumProgramType,
    }) &&
    !isEmptyAchievementCriteria &&
    canUserSeeRateLearningGoals;

  const isAttachmentGroupEmpty = _.isEmpty(attachmentGroups);

  const { isScoreEnabled, maxScore } = getScoreDetailsMemoize({
    assessmentTools: {
      edges: assessmentTools,
    },
  });

  const isScoringEnabled =
    _.get(
      _.find(
        assessmentTools,
        ({ node }) => _.get(node, "assessmentToolType", "") == "SCORE"
      ),
      "node.isTeacherEvaluationEnable",
      false
    ) &&
    isScoreEnabled &&
    maxScore;

  let scoreValue = 0;
  if (isScoringEnabled) {
    scoreValue = getScoreValueElementRatings({
      ibPYPElementRatings,
    });
  }

  const toolsHavingData = _.filter(assessmentTools, ({ node }) => {
    const assessmentTool = _.get(node, "assessmentToolItem", BLANK_OBJECT);
    const assessmentToolType = _.get(node, "assessmentToolType", "");

    const isTeacherEvaluationEnable = _.get(
      node,
      "isTeacherEvaluationEnable",
      false
    );
    const isStudentEvaluationEnable = _.get(
      node,
      "isStudentEvaluationEnable",
      false
    );

    return (
      getShowAssessmentTool({
        assessmentTool,
        assessmentToolType,
        allFields: assessmentFields,
      }) &&
      (isTeacherEvaluationEnable || isStudentEvaluationEnable)
    );
  });

  const showAssessmentToolCard =
    shouldShowEvaluationTools && !_.isEmpty(toolsHavingData);

  const totalItems =
    _.size(attachmentsToDisplay) +
    _.size(postAttachments) +
    (showRateLearningGoals ? 1 : 0) +
    (showAssessmentToolCard ? _.size(toolsHavingData) : 0);

  const [currentScrollPosition, setCurrentScrollPosition] = useState(0);
  const [isLeftButtonVisible, setIsLeftButtonVisible] = useState(
    currentScrollPosition > 0
  );
  const [isRightButtonVisible, setIsRightButtonVisible] = useState(
    totalItems > 1
  );

  const innerContainerClass = classNames({
    [classes.innerContainer]: true,
    [classes.innerContainerPreview]: isPreviewCard,
  });

  const wrapperClass = classNames({
    [classes.wrapper]: isSidePaneContent,
    [classes.wrapperPreview]: !isSidePaneContent,
  });

  const scrollResponseToLeft = e => {
    e.stopPropagation();
    if (!isRightButtonVisible) setIsRightButtonVisible(true);

    // When user reached at first item on left side
    if (currentScrollPosition + attachmentCardWidth >= 0) {
      setCurrentScrollPosition(0);
      setIsLeftButtonVisible(false);
    } else
      setCurrentScrollPosition(currentScrollPosition + attachmentCardWidth);
  };
  const scrollResponseToRight = e => {
    e.stopPropagation();
    if (!isLeftButtonVisible) setIsLeftButtonVisible(true);

    // When user reached at last item on right side
    if (
      -(attachmentCardWidth * Math.max(totalItems - 1, 0)) ==
      currentScrollPosition - attachmentCardWidth
    ) {
      setCurrentScrollPosition(currentScrollPosition - attachmentCardWidth);
      setIsRightButtonVisible(false);
    } else {
      setCurrentScrollPosition(currentScrollPosition - attachmentCardWidth);
    }
  };

  // Assessment tools evaluation details for theatre mode which includes tool responses and various boolean fields to render tools.
  const assessmentToolsEvaluationDetails = {
    toolEvaluationResponses: toolResponsesData,
    isStudentEvaluationEnabled: isStudentEvaluationEnabled,
    assessmentFields: assessmentFields,
    field_list: field_list,
    unitPlanFields: unitPlanFields,
    parentType: "STUDENT_ASSIGNMENT",
    parentId: _.get(item, "id"),
    studentId: _.get(item, "student.id"),
    ibPYPElementRatings: _.get(item, "ibPYPElementRatings"),
    isTeacherEvaluationEnabled: isTeacherEvaluationEnabled,
    commentMessage: commentMessage,
    showRatingContainerInViewMode:
      isFinalCriteriaSettingEnabled &&
      _.includes(
        ["MYP_OBJECTIVE_RUBRIC", "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC"],
        assessmentToolTypeLocal
      ) &&
      isEvaluated &&
      isSharedWithStudent &&
      isTeacherEvaluationEnabledLocal,
    studentDetails: student,
    course: course,
    isComplete: true,
    showToggleStudentPypEvaluateStatus: false,
    evaluateIBPYPElements: true,
    isSharedWithStudent: isSharedWithStudent,
  };

  const [showMediaModal, setShowMediaModal] = useState(false);
  const [currentAttachment, setCurrentAttachment] = useState({});
  const attachmentsFromGroups = _.map(attachmentsToDisplay, attachmentGroup =>
    _.get(attachmentGroup, "attachments[0]")
  );

  const submissionId = _.get(submission, "id");

  const onClickMedia = ({
    event,
    attachmentData,
    activeIndex = 0,
    showLearningGoalsInTheatre = false,
  } = {}) => {
    if (event && event.stopPropagation) event.stopPropagation();
    setShowMediaModal(true);
    setCurrentAttachment({
      attachments: !_.isUndefined(attachmentData)
        ? attachmentData
        : [...attachmentsFromGroups, ...postAttachments],
      activeIndex: activeIndex,
      showLearningGoalsInTheatre,
    });
  };

  useEffect(() => {
    if (showNewTheatreMode() && showTheatreModeOnInit == true) {
      if (totalItems == 1 && showRateLearningGoals) {
        onClickMedia({ showLearningGoalsInTheatre: true });
      } else if (
        _.size(attachmentsToDisplay, 0) == 0 &&
        _.size(toolsHavingData, 0) > 0
      ) {
        onClickMedia({ activeIndex: 0 }); // show first assessment tool
      } else {
        onClickMedia({ attachmentData: attachmentsFromGroups, activeIndex: 0 });
      }
    }
  }, [showTheatreModeOnInit]);

  const toggleMediaModal = useCallback(() => {
    showMediaModal && setRefetchComment(true);
    setShowMediaModal(!showMediaModal);
    if (_.isFunction(toggleParentMediaModalState)) {
      // if theatre mode is initiated from parent PostCard, then on close we should toggle its showMediaModal state.
      // otherwise it will remain true, and we cannot open same post details again.
      toggleParentMediaModalState(false);
    }
    if (hideComments) return;
    syncPostCommentsCache({
      postId: _.get(props, "post.id"),
      variables: { first: 1 },
      fragment: PostCommentFragment,
    });
  }, [showMediaModal]);

  const evaluationContent = useMemo(
    () => ({
      name: assessmentToolTitle,
      assessmentTools: _.get(content, "assessmentTools", BLANK_ARRAY),
    }),
    [content]
  );

  const textMoreStyles = { textDecoration: "none" };
  return (
    <React.Fragment>
      <MediaModalWrapper
        postIdFromParent={_.get(props, "postIdFromParent")}
        attachments={currentAttachment}
        toggleMediaModal={toggleMediaModal}
        showMediaModal={showMediaModal}
        assessmentToolsEvaluationDetails={assessmentToolsEvaluationDetails}
        studentSubmissionId={submissionId}
        getStudentAssignmentMicrosoftLink={getStudentAssignmentMicrosoftLink}
        evaluationContent={{
          name: assessmentToolTitle,
          assessmentTools: _.get(content, "assessmentTools", BLANK_ARRAY),
        }}
        post={props?.post}
        curriculumProgramType={curriculumProgramType}
        t={t}
        showLearningGoalsInTheatre={_.get(
          currentAttachment,
          "showLearningGoalsInTheatre"
        )}
        onPostActionClick={onPostActionClick}
        hasRateLearningGoals={showRateLearningGoals}
        canCreateComment={canCreateComment}
        postViewMode={postViewMode}
        updatePostStatus={updatePostStatus}
        hideViews={hideViews}
        hideLike={hideLike}
        hideComments={hideComments}
        hideLearninGoals={hideLearninGoals}
        hideTaggedStudents={hideTaggedStudents}
        hideUnitDetails={hideUnitDetails}
        showTaggedFolders={showTaggedFolders}
        postRatedLearningGoalsDetails={postRatedLearningGoalsDetails}
        taggedStudents={taggedStudents}
        shouldShowEvaluationTools={shouldShowEvaluationTools}
        canDownloadMedia={canDownloadMedia}
        showCommentButton={_.get(props, "showCommentButton")}
        isViewFromPostPage={isViewFromPostPage}
        cardType={cardType}
        canEditOrDelete={canEditOrDelete}
        hideMoveToDraftOption={hideMoveToDraftOption}
        assessmentId={assessmentId}
        assignmentId={assignmentId}
        hasManageAccess={hasManageAccess}
        learningCourseId={learningCourseId}
      />
      {showAssessmentTool && (
        <AssessmentToolPreviewModalV2
          id={assessmentToolIdLocal}
          type={assessmentToolTypeLocal}
          entityType={_.get(
            _.find(ASSESSMENT_TOOLS, { type: assessmentToolTypeLocal }),
            "entityType",
            ""
          )}
          mode={"view"}
          toolResponses={toolResponses}
          title={assessmentToolText}
          showChooseButton={false}
          onClickClose={() => setShowAssessmentTool(false)}
          isEvaluatedByStudent={isStudentEvaluationEnabledLocal}
          unitPlanFields={unitPlanFields}
          assessmentFields={assessmentFields}
          field_list={field_list}
          parentId={studentAssignmentId}
          parentType={"STUDENT_ASSIGNMENT"}
          studentid={_.get(student, "id", "")}
          ibPYPElementRatings={ibPYPElementRatings}
          isTeacherEvaluationEnabled={isTeacherEvaluationEnabledLocal}
          commentMessage={commentMessage}
          showRatingContainerInViewMode={
            isFinalCriteriaSettingEnabled &&
            _.includes(
              ["MYP_OBJECTIVE_RUBRIC", "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC"],
              assessmentToolTypeLocal
            ) &&
            isEvaluated &&
            isSharedWithStudent
          }
          maxScore={maxScore}
          scoreValue={scoreValue}
          showEvaluateStatus={true}
        />
      )}
      {showRateLearningGoalsModal && (
        <RateOnLearningGoalsPreviewModal
          isComplete={true}
          parentId={studentAssignmentId}
          parentType={"STUDENT_ASSIGNMENT"}
          showToggleStudentPypEvaluateStatus={false}
          evaluateIBPYPElements={true}
          studentDetails={student}
          assessmentFields={assessmentFields}
          ibPYPElementRatings={ibPYPElementRatings}
          isEvaluated={true}
          curriculumProgramType={curriculumProgramType}
          course={course}
          setShowRateLearningGoalsModal={setShowRateLearningGoalsModal}
          t={t}
        />
      )}
      {totalItems > 0 || !_.isEmpty(commentTool) || !_.isEmpty(response) ? (
        !isSidePaneContent ? (
          <div className={classes.container} style={containerStyle}>
            <div
              className={innerContainerClass}
              style={{ position: "relative" }}
            >
              {!_.isEmpty(response) && (
                <div className={classes.response} style={responseStyle}>
                  {showSeeMore ? (
                    <TextMoreLess
                      value={response}
                      minHeight={48}
                      customTextStyle={textMoreStyles}
                    />
                  ) : (
                    response
                  )}
                </div>
              )}
              <div
                className={classes.scrollButtonsContainer}
                style={scrollButtonsContainerStyle}
              >
                {isLeftButtonVisible && (
                  <div className={classes.leftScrollButton}>
                    <IconButton
                      icon={<ChevronLeftOutlined />}
                      onClick={scrollResponseToLeft}
                      variant="plain"
                      className={classes.responseScrollButton}
                    />
                  </div>
                )}
                {isRightButtonVisible && (
                  <div className={classes.rightScrollButton}>
                    <IconButton
                      icon={<ChevronRightOutlined />}
                      onClick={scrollResponseToRight}
                      variant="plain"
                      className={classes.responseScrollButton}
                    />
                  </div>
                )}
              </div>
              <div className={classes.wrapperClassContainer}>
                <div
                  className={wrapperClass}
                  style={{
                    transform: `translateX(${currentScrollPosition}px)`,
                  }}
                >
                  {!isAttachmentGroupEmpty || _.size(postAttachments) ? (
                    <div
                      className={classes.attachmentListContainer}
                      style={{ width: totalItems == 1 ? "100%" : "initial" }}
                    >
                      {
                        <AttachmentsContainer
                          attachments={attachmentsToDisplay}
                          postAttachments={postAttachments}
                          itemStyles={{
                            padding: "16px",
                            borderRadius: "8px",
                          }}
                          isStudentResponse={true}
                          containerStyle={{
                            height: "284px",
                            width: totalItems == 1 ? "initial" : "284px",
                            ...(mediaPlaceholderContainerStyle ?? {}),
                          }}
                          attachmentsContainerStyle={{
                            display: totalItems == 1 ? "flex" : "grid",
                          }}
                          isSidePaneContent={props.isSidePaneContent ?? false}
                          assessmentFields={assessmentFields}
                          t={t}
                          isStudentEvaluationEnabled={
                            isStudentEvaluationEnabled
                          }
                          isTeacherEvaluationEnabled={
                            isTeacherEvaluationEnabled
                          }
                          evaluationContent={{
                            name: assessmentToolTitle,
                            assessmentTools: _.get(
                              content,
                              "assessmentTools",
                              BLANK_ARRAY
                            ),
                          }}
                          assessmentToolsEvaluationDetails={
                            assessmentToolsEvaluationDetails
                          }
                          onClickMedia={onClickMedia}
                          parentId={studentAssignmentId}
                        />
                      }
                    </div>
                  ) : null}
                  {shouldShowEvaluationTools ? (
                    <StudentResponseEvaluation
                      t={t}
                      isAttachmentGroupEmpty={isAttachmentGroupEmpty}
                      evaluationTextStyle={evaluationTextStyle}
                      showEvaluation={showEvaluation}
                      isPreviewCard={isPreviewCard}
                      setShowAssessmentTool={setShowAssessmentTool}
                      setShowRateLearningGoalsModal={
                        setShowRateLearningGoalsModal
                      }
                      showRateLearningGoals={showRateLearningGoals}
                      isFullWidth={totalItems == 1 && showFullWidthItems}
                      assessmentTools={assessmentTools}
                      setAssessmentToolInfo={setAssessmentToolInfo}
                      isTeacherEvaluationEnabled={isTeacherEvaluationEnabled}
                      isStudentEvaluationEnabled={isStudentEvaluationEnabled}
                      assessmentFields={assessmentFields}
                      commentMessage={commentMessage}
                      showAssessmentToolCard={showAssessmentToolCard}
                      evaluationCardStyle={evaluationCardStyle}
                      iconSize={iconSize}
                      assessmentToolTextStyle={assessmentToolTextStyle}
                      onClickMedia={onClickMedia}
                      totalAttachments={
                        _.size(attachmentsToDisplay) + _.size(postAttachments)
                      }
                    />
                  ) : null}
                </div>

                {commentMessage && shouldShowEvaluationTools && (
                  <div className={classes.teacherRemarkContainer}>
                    <div className={"text-label-3"}>
                      {t("common:final_remarks")}
                    </div>
                    <div className={"text-body-2"}>{commentMessage}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            className={classes.sidePaneContainer}
            style={sidePaneContainerStyle}
          >
            <AttachmentsContainer
              attachments={attachmentsToDisplay}
              postAttachments={postAttachments}
              itemStyles={{ padding: "16px", borderRadius: "8px" }}
              isStudentResponse={true}
              containerStyle={{ height: "284px", width: "284px" }}
              isSidePaneContent={props.isSidePaneContent ?? false}
              hasAssesmentTool={showAssessmentToolCard}
              hasLearningGoals={showRateLearningGoals}
              evaluationContent={{
                name: assessmentToolTitle,
                assessmentTools: _.get(content, "assessmentTools", []),
              }}
              setShowAssessmentTool={setShowAssessmentTool}
              setAssessmentToolInfo={setAssessmentToolInfo}
              setShowRateLearningGoalsModal={setShowRateLearningGoalsModal}
              responseCaption={response}
              commentMessage={commentMessage}
              assessmentFields={assessmentFields}
              t={t}
              isStudentEvaluationEnabled={isStudentEvaluationEnabled}
              isTeacherEvaluationEnabled={isTeacherEvaluationEnabled}
              assessmentToolsEvaluationDetails={
                assessmentToolsEvaluationDetails
              }
              onClickMedia={onClickMedia}
              setTheatreAttachmentIndex={setTheatreAttachmentIndex}
              theatreActiveAttachmentId={theatreActiveAttachmentId}
              setTheatreAttachmentById={setTheatreAttachmentById}
              parentId={studentAssignmentId}
              shouldShowEvaluationTools={shouldShowEvaluationTools}
            />
          </div>
        )
      ) : null}
    </React.Fragment>
  );
});

StudentResponseV2.defaultProps = {
  showEvaluation: true,
};

const mapStateToProps = (state, ownProps) => {
  const courseId = _.get(state, "teacher.selected_class.selected_course");
  const academicYearId = getSelectedAcademicYearId(state);
  const courseGradeFilters = {
    academicYearId,
  };
  const course = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters,
  });
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    "IB_PYP"
  );

  const userType = _.get(state, "login.userInfo.user_type", "");
  const userEntityType = _.get(state, "login.userInfo.userEntityType", "");
  const organizationId = _.get(state, "login.userInfo.org_id", "");
  const postAttachments =
    _.size(_.get(state, "post.postDetails.attachments", BLANK_ARRAY)) &&
    !_.get(ownProps, "isPostFeed", false)
      ? _.get(state, "post.postDetails.attachments", BLANK_ARRAY)
      : _.get(ownProps, "workSheetPostAttachments", BLANK_ARRAY);

  const isFinalCriteriaSettingEnabled = getSettingValue({
    name:
      userType === "student"
        ? "ShowFinalGradeRatingToStudent"
        : "ShowFinalGradeRatingToParent",
    organizationId,
    userEntityType,
  });

  const isFromJournalRoute = _.includes(
    _.get(window, "location.pathname", ""),
    "/journal"
  );

  const shouldShowEvaluationTools = isFromJournalRoute
    ? userType !== "parent" ||
      (userType === "parent" &&
        getSettingValue({
          name: "FamilyCanViewEvaluation",
          currentCurriculumProgramId: getSelectedCurriculumId(state),
        }))
    : true;

  const canDownloadMedia =
    userType != "parent" ||
    (userType == "parent" &&
      getSettingValue({
        name: "FamilyCanDownloadMedia",
        currentCurriculumProgramId: getSelectedCurriculumId(state),
      }));
  return {
    course,
    curriculumProgramType,
    isFinalCriteriaSettingEnabled,
    shouldShowEvaluationTools,
    canDownloadMedia,
    userType: userType,
    postAttachments,
  };
};

const mapActionCreators = {
  getCriteriaSetOfPypType,
  updatePostStatus,
  getStudentAssignmentMicrosoftLink,
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators)
)(StudentResponseV2);

StudentResponseV2.displayName = "StudentResponseV2";
